/**
 * Chart configuration for the AI Agents Insights widget.
 *
 * Scoped locally (not shared with the Overview page) so we can add AI-Agents-only
 * metrics like `responseTime` without widening the shared `MetricKey` union.
 */

import { CSAT_TICKS, formatCsatTick, type MetricChartConfig } from '../../utils/chartConfig';

export type AiAgentMetricKey = 'csat' | 'containment' | 'responseTime' | 'totalConversations';

export const AI_AGENTS_METRIC_CHART_CONFIGS: Record<AiAgentMetricKey, MetricChartConfig> = {
  csat: {
    dataKey: 'value',
    label: 'analytics.overview_new.avg_ai_csat',
    domain: [0, 5],
    valueFormatter: (value) => value.toFixed(1),
    ticks: CSAT_TICKS,
    tickFormatter: formatCsatTick,
    fill: 'gap',
  },
  containment: {
    dataKey: 'value',
    label: 'analytics.containment',
    domain: [0, 100],
    valueFormatter: (value) => `${value}%`,
    fill: 'gap',
  },
  responseTime: {
    dataKey: 'value',
    label: 'analytics.response_time',
    domain: [0, 'auto'],
    valueFormatter: (value) => `${value.toFixed(1)}s`,
    fill: 'gap',
  },
  totalConversations: {
    dataKey: 'value',
    label: 'analytics.total_conversations',
    domain: [0, 'auto'],
    valueFormatter: (value) => value.toLocaleString(),
    fill: 'zero',
  },
};
